/// <amd-module name="Wit/WorkItemForm/Common/Components/StateCircle" />
import * as React from "react";
import { useMemo } from "react";
import { ITooltipProps, Tooltip } from "VSSUI/TooltipEx";
import { IWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { useWorkItem } from "../Hooks";

interface IStateCircleProps {
    state: string;
    color?: string;
    workItem?: IWorkItem;
    className?: string;
    role?: string;
    hideIfUnknownState?: boolean;
    tooltipProps?: ITooltipProps;
}

export function StateCircle({ state, color, workItem, className, role, hideIfUnknownState, tooltipProps }: IStateCircleProps) {
    let defaultWorkItem: IWorkItem | undefined;
    try {
        defaultWorkItem = useWorkItem();
    } catch (e: unknown) {
        defaultWorkItem = undefined;
    }

    workItem = workItem ?? defaultWorkItem;

    const workItemTypeData = workItem?.getTypeData();
    const background = useMemo(() => color ?? getStateColor(state, workItemTypeData), [state, color, workItemTypeData]);

    if (!background && hideIfUnknownState) {
        return null;
    }

    return (
        <Tooltip {...tooltipProps}>
            <div role={role} className={`state-circle ${className}`} style={{ background }} />
        </Tooltip>
    );
}

function getStateColor(state: string, workItemTypeData: IWorkItemTypeData | undefined): string | undefined {
    for (const stateColor of workItemTypeData?.rules?.stateColors ?? []) {
        if (stateColor.name === state) {
            return `#${stateColor.color}`;
        }
    }
    return undefined;
}
